export const saas = {
  // Pricing page
  pricing: {
    title: 'Válaszd ki a neked megfelelő csomagot',
    subtitle: 'Minden csomag 14 napos próbaidőszakkal indul. Nincs kötelezettség, bármikor lemondhatod.',
    monthly: 'Havi',
    yearly: 'Éves',
    yearlyDiscount: '-17%',
    free: 'Ingyenes',
    perMonth: 'Ft/hó',
    perYear: 'Ft/év',
    plusVAT: '+ ÁFA',
    startFree: 'Kezdés ingyen',
    startTrial: '14 napos próba',
    startNow: 'Kezdés most',
    notSure: 'Bizonytalan? Próbáld ki ingyen 14 napig.',
    popular: 'LEGNÉPSZERŰBB',
    popularBadge: 'Népszerű',
    unlimited: 'Korlátlan',
    users: 'felhasználó',
    storage: 'GB tárhely',
    organizations: 'szervezet',
    login: 'Bejelentkezés',
    loadingPackages: 'Csomagok betöltése...',
    // FAQ
    faqTitle: 'Gyakori kérdések',
    faq1Q: 'Mennyi ideig tart a próbaidőszak?',
    faq1A: 'Minden csomag 14 napos próbaidőszakkal indul. A próba alatt minden funkció használható, nem kell bankkártyát megadni.',
    faq2Q: 'Bármikor lemondhatom az előfizetést?',
    faq2A: 'Igen, az előfizetést bármikor lemondhatod a beállításokban. A lemondás az aktuális számlázási időszak végéig marad aktív.',
    faq3Q: 'Válthatok csomagot később?',
    faq3A: 'Igen, bármikor válthatsz magasabb vagy alacsonyabb csomagra. A különbség automatikusan elszámolásra kerül.',
  },
  
  // Onboarding wizard
  wizard: {
    // Steps
    stepOrganization: 'Szervezet',
    stepPackage: 'Csomag',
    stepConfirmation: 'Megerősítés',
    
    // Step 0: Organization
    orgTitle: 'Szervezet adatai',
    orgSubtitle: 'Add meg a szervezeted alapvető adatait. Ezeket később módosíthatod.',
    orgName: 'Szervezet neve',
    orgNameRequired: 'A szervezet neve kötelező',
    orgNamePlaceholder: 'Példa Kft.',
    taxNumber: 'Adószám',
    taxNumberPlaceholder: '12345678-2-43',
    industry: 'Iparág',
    industryPlaceholder: 'Válassz iparágat',
    industryIt: 'Informatika / IT',
    industryMarketing: 'Marketing / Reklám',
    industryConsulting: 'Tanácsadás',
    industryTrade: 'Kereskedelem',
    industryManufacturing: 'Gyártás',
    industryConstruction: 'Építőipar',
    industryServices: 'Szolgáltatás',
    industryHealthcare: 'Egészségügy',
    industryEducation: 'Oktatás',
    industryFinance: 'Pénzügy',
    industryOther: 'Egyéb',
    
    // Address
    addressTitle: 'Cím',
    street: 'Utca, házszám',
    streetPlaceholder: 'Példa utca 1.',
    city: 'Város',
    cityPlaceholder: 'Budapest',
    postalCode: 'Irányítószám',
    postalCodePlaceholder: '1000',
    country: 'Ország',
    
    // Contact
    contactTitle: 'Kapcsolattartó',
    contactName: 'Név',
    contactNamePlaceholder: 'Teljes név',
    contactEmail: 'E-mail',
    contactEmailPlaceholder: 'email@pelda.hu',
    contactPhone: 'Telefon',
    contactPhonePlaceholder: '+36 30 123 4567',
    contactPosition: 'Beosztás',
    contactPositionPlaceholder: 'Ügyvezető',
    
    // Step 1: Package
    packageTitle: 'Csomag választása',
    packageSubtitle: 'Válassz egy csomagot. Minden csomaghoz 14 napos próbaidőszak tartozik.',
    billingMonthly: 'Havi',
    billingYearly: 'Éves',
    billingYearlyNote: '(2 hónap ingyen)',
    trialInfo: 'A 14 napos próbaidőszak alatt minden funkció használható. A próba lejárta után dönthetsz, hogy fizetős csomagra váltasz-e.',
    
    // Step 2: Confirmation
    confirmTitle: 'Megerősítés',
    confirmSubtitle: 'Ellenőrizd az adatokat és erősítsd meg a regisztrációt.',
    confirmOrganization: 'Szervezet',
    confirmName: 'Név:',
    confirmIndustry: 'Iparág:',
    confirmTaxNumber: 'Adószám:',
    confirmPackage: 'Csomag',
    confirmFreePackage: 'Ingyenes csomag',
    confirmTrial: '14 napos próbaidőszak',
    confirmReady: 'Készen állsz a kezdésre!',
    confirmReadyDesc: 'A megerősítés után azonnal hozzáférhetsz a rendszerhez.',
    
    // Buttons
    back: 'Vissza',
    next: 'Tovább',
    createOrg: 'Szervezet létrehozása',
    creating: 'Létrehozás...',
    signOut: 'Kijelentkezés',
    
    // Messages
    successMsg: 'Szervezet sikeresen létrehozva! Üdvözöljük a YouCRM-ben!',
    errorMsg: 'Hiba történt a szervezet létrehozása során',
    
    // Success screen
    successTitle: 'Minden készen áll!',
    successSubtitle: 'A szervezet sikeresen létrejött. Kattints a gombra a kezdéshez.',
    startUsing: 'Használat megkezdése',
  },
  
  // Payments / Subscriptions page
  payments: {
    total: 'Összes',
    completed: 'Sikeres',
    pending: 'Folyamatban',
    failed: 'Sikertelen',
    revenue: 'Bevétel',
    searchPlaceholder: 'Keresés rendelésszám, ügyfél vagy leírás alapján...',
    allStatuses: 'Minden státusz',
    allTypes: 'Minden típus',
    orderNumber: 'Rendelésszám',
    customer: 'Ügyfél',
    productService: 'Termék/Szolgáltatás',
    type: 'Típus',
    amount: 'Összeg',
    status: 'Státusz',
    date: 'Dátum',
    actions: 'Műveletek',
    noPayments: 'Nincs megjeleníthető fizetés',
    paid: 'Fizetve:',
    refund: 'Visszatérítés',
    // Status labels
    statusPending: 'Várakozik',
    statusProcessing: 'Feldolgozás',
    statusCompleted: 'Sikeres',
    statusFailed: 'Sikertelen',
    statusCancelled: 'Megszakítva',
    statusRefunded: 'Visszatérítve',
    statusPartialRefund: 'Részben visszatérítve',
    // Purpose labels
    purposeSubscription: 'Előfizetés',
    purposeInvoice: 'Számla',
    purposeProforma: 'Díjbekérő',
    purposeTicketDeposit: 'Ticket előleg',
    purposeTicketService: 'Ticket szolgáltatás',
    purposeOther: 'Egyéb',
    // Summary
    subscriptionsTitle: 'Előfizetések',
    invoicesTitle: 'Számlák',
    otherTitle: 'Egyéb',
    active: 'aktív',
    paidCount: 'kifizetve',
    successful: 'sikeres',
  },
  
  // Billing page
  billing: {
    newDocument: 'Új bizonylat',
    invoiceDraft: 'Számla vázlat',
    invoiceDraftDesc: 'Új számla létrehozása',
    proformaDraft: 'Díjbekérő vázlat',
    proformaDraftDesc: 'Új díjbekérő létrehozása',
    receipt: 'Nyugta',
    receiptDesc: 'Új nyugta létrehozása',
    receiptComingSoon: 'Nyugta funkció hamarosan elérhető',
  },
  
  // Legal pages
  legal: {
    // Terms of Service
    termsTitle: 'Felhasználási Feltételek',
    termsIntroTitle: 'Bevezetés',
    termsIntro: 'Üdvözöljük a YouCRM-ben! Ezek a Felhasználási Feltételek szabályozzák a CRM rendszerünk használatát és az általunk nyújtott szolgáltatásokat. A szolgáltatások elérésével vagy használatával Ön elfogadja, hogy ezek a feltételek kötelezőek Önre nézve.',
    termsAccessTitle: 'Hozzáférés és használat',
    termsAccess: 'Ez a rendszer érzékeny üzleti információkat tartalmaz, és csak jogosult személyek férhetnek hozzá. A rendszer jogosulatlan elérése vagy használata szigorúan tilos.',
    termsAccountTitle: 'Fiók biztonsága',
    termsAccount: 'Ön felelős a fiókja hitelesítő adatainak bizalmas kezeléséért. Minden, az Ön fiókja alatt történő tevékenységért Ön a felelős.',
    termsPrivacyTitle: 'Adatvédelem',
    termsPrivacy: 'Megfelelő biztonsági intézkedéseket hajtunk végre az Ön adatainak védelme érdekében. Az adatkezelésünkről további információkat az Adatvédelmi Szabályzatban találhat.',
    termsAvailabilityTitle: 'Szolgáltatás elérhetősége',
    termsAvailability: 'Törekszünk a folyamatos szolgáltatásnyújtásra, de nem garantálhatjuk, hogy a szolgáltatás mindig elérhető lesz. Fenntartjuk a jogot a szolgáltatás felfüggesztésére vagy megszüntetésére karbantartás vagy egyéb okok miatt.',
    termsLiabilityTitle: 'Felelősség korlátozása',
    termsLiability: 'A YouCRM nem vállal felelősséget semmilyen közvetett, véletlen, különleges, következményes vagy büntető jellegű kárért, amely a szolgáltatás használatából vagy annak használatára való képtelenségből ered.',
    termsIntellectualTitle: 'Szellemi tulajdon',
    termsIntellectual: 'A YouCRM és annak tartalma, beleértve a szoftvert, design elemeket, védjegyeket és szerzői jogvédelem alatt álló anyagokat, a WEBISSIMO Kft. kizárólagos tulajdonát képezik. Ezek másolása, módosítása vagy terjesztése tilos.',
    termsTerminationTitle: 'Felmondás',
    termsTermination: 'Bármikor felmondhatja előfizetését. A felmondás az aktuális számlázási időszak végéig marad aktív. Fenntartjuk a jogot a hozzáférés azonnali letiltására a feltételek megsértése esetén.',
    termsPaymentTitle: 'Fizetés és előfizetés',
    termsPayment: 'Az előfizetési díjakat előre, a választott csomagnak megfelelően számítjuk fel. Az összes ár az általános forgalmi adót (ÁFA) nem tartalmazza, azt a számlán külön feltüntetjük.',
    termsGoverningTitle: 'Alkalmazandó jog',
    termsGoverning: 'Jelen Felhasználási Feltételekre a magyar jog az irányadó. A felmerülő vitákat a magyar bíróságok illetékessége alapján rendezzük.',
    
    // Privacy Policy
    privacyTitle: 'Adatkezelési tájékoztató',
    privacyIntroTitle: 'Bevezetés',
    privacyIntro: 'A YouCRM elkötelezett az Ön adatainak védelme mellett. Ez az Adatkezelési tájékoztató elmagyarázza, hogyan gyűjtjük, használjuk és védjük az Ön adatait, amikor a YouCRM rendszerünket használja.',
    privacyCollectTitle: 'Milyen adatokat gyűjtünk',
    privacyCollect: 'Olyan információkat gyűjtünk, amelyeket Ön közvetlenül szolgáltat számunkra, beleértve a személyes adatokat, mint például a nevét, e-mail címét és egyéb kapcsolattartási adatait. Továbbá gyűjtjük az Ön ügyfeleivel, beszállítóival és üzleti partnereivel kapcsolatos információkat, amelyeket Ön a rendszerbe rögzít.',
    privacyUseTitle: 'Hogyan használjuk az adatait',
    privacyUse: 'Az általunk gyűjtött információkat a szolgáltatásaink nyújtására, fenntartására és javítására, új funkciók fejlesztésére, valamint felhasználóink védelmére használjuk. A rendszer érzékeny üzleti információkat tartalmaz, amelyekhez csak jogosult személyek férhetnek hozzá.',
    privacySecurityTitle: 'Adatbiztonság',
    privacySecurity: 'Megfelelő biztonsági intézkedéseket hajtunk végre az Ön adatainak jogosulatlan hozzáféréstől, módosítástól, közzétételtől vagy megsemmisítéstől való védelme érdekében. Azonban nincs olyan internetes adatátviteli vagy elektronikus tárolási módszer, amely 100%-ban biztonságos lenne.',
    privacyRetentionTitle: 'Adatmegőrzés',
    privacyRetention: 'Adatait mindaddig megőrizzük, amíg fiókja aktív, vagy amíg szükséges a szolgáltatások nyújtásához. Adatait a szükséges mértékben megtartjuk és felhasználjuk jogi kötelezettségeink teljesítése, viták rendezése és megállapodásaink betartatása érdekében.',
    privacyRightsTitle: 'Az Ön jogai',
    privacyRights: 'Ön jogosult hozzáférni adataihoz, azokat helyesbíteni vagy törölni. Kérheti adatai hordozhatóságát, valamint tiltakozhat az adatkezelés ellen. Jogainak gyakorlásához vegye fel velünk a kapcsolatot.',
    privacyCookiesTitle: 'Sütik (Cookies)',
    privacyCookies: 'A YouCRM sütiket használ a szolgáltatás működéséhez és a felhasználói élmény javításához. A sütik small szöveges fájlok, amelyeket a böngészője tárol. A sütiket letilthatja a böngésző beállításaiban.',
    privacyChangesTitle: 'Az Adatkezelési tájékoztató módosításai',
    privacyChanges: 'Időről időre frissíthetjük az Adatkezelési tájékoztatónkat. Az esetleges változásokról értesítjük Önt az új Adatkezelési tájékoztató ezen az oldalon történő közzétételével és a hatályba lépés dátumának frissítésével.',
    
    // Company info
    companyTitle: 'Szolgáltató',
    companyName: 'WEBISSIMO Korlátolt Felelősségű Társaság',
    companyReg: 'Cégjegyzékszám: 13-09-242688',
    companyTax: 'Adószám: 32894787-2-13',
    companyAddress: 'Székhely: 2161 Csomád, Szent István utca 48.',
    backToLogin: 'Vissza a bejelentkezéshez',
    fullDocsUrl: 'https://youcrm.hu/docs',
    viewFullDocs: 'A teljes dokumentum megtekintése →',
  }
};
